/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { AddAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { chain, SendActivationEmail } from "@insite/client-framework/Store/Pages/UserList/Handlers/CreateUser";
import sendActivationEmail from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SendActivationEmail";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        userName: string;
        email: string;
        firstName: string;
        lastName: string;
        role: string;
        approver: string;
        requiresActivationCheck: boolean;
    } & HasOnSuccess &
        HasOnError<string>,
    AddAccountApiParameter,
    ServiceResult<AccountModel>
>;

// Prevent calling sendActivationEmail if the checkbox not checked
export const XngSendActivationEmail: HandlerType = async props => {
    if (props.apiResult.successful && (props.apiParameter.account as any).requiresActivationCheck) {
        const awaitableSendActivationEmail = makeHandlerChainAwaitable(sendActivationEmail);
        await awaitableSendActivationEmail({ userName: props.apiResult.result.userName })(
            props.dispatch,
            props.getState,
        );
    }
};

replaceInChain(chain, SendActivationEmail, XngSendActivationEmail);
